<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>


<div class="add-association-btn">
  <button mat-fab color="primary" matTooltip="Dodaj novu udrugu" (click)="goToToCreateAssociation()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<!-- Associations Cards -->
<div class="associations-container">
  @for (association of filteredAssociations; track association) {
    <div class="col-lg-4 col-md-6 association-card">
      <mat-card class="daxa-card border-radius bg-white border-none">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ association.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Oib:</strong> {{ association.oib }}</p>
          <p><strong>Email:</strong> {{ association.email }}</p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj udrugu" (click)="goToViewAssociation(association)">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button color="primary" matTooltip="Uredi udrugu" (click)="goToToEditAssociation(association)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Obriši udrugu" (click)="confirmDelete(association)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>

  </div>
}
</div>